import { BaseApiService, apiClient } from 'shared/api/client';


export class SectionService extends BaseApiService {
    constructor() {
        super('/dashboard/admin-api/sections');
    }

    

    addSubSection(sectionId, subSectionData, token = 'token') {
        return apiClient.post(
            `${this.endpoint}/${sectionId}/sub-sections/`,
            subSectionData,
            token
        );
    }

    updateSubSections(sectionId, subSectionsData, token = 'token') {
        return apiClient.put(
            `${this.endpoint}/${sectionId}/sub-sections/`,
            subSectionsData,
            token
        );
    }

    removeSubSection(sectionId, subSectionId, token = 'token') {
        return apiClient.delete(
            `${this.endpoint}/${sectionId}/sub-sections/`,
            { id: subSectionId },
            token
        );
    }

    




}

export const sectionService = new SectionService();
